import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { DatePipe, SlicePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { RouterLink } from "@angular/router";

import { NotificationType } from "../../../apis/networkdashboard/graphql/graphql";
import { DialogActivityComponent } from "../../dialogs/dialog-activity/dialog-activity";

@Component({
  selector: "notification-container",
  templateUrl: "notification-container.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, DatePipe, RouterLink, SlicePipe, TranslatePipe],
})
export class NotificationContainer {
  private dialog = inject(MatDialog);

  protected messages = input.required<NotificationType[]>();
  protected notificationType = input.required<"planned" | "unplanned">();
  protected noMessages = computed(() => this.messages().length === 0);
  protected isUnplanned = computed(() => this.notificationType() === "unplanned");
  protected boxTitle = computed(() =>
    this.isUnplanned() ? "Overview.Activities.Unplanned" : "Overview.Activities.Planned",
  );
  protected boxIcon = computed(() => (this.notificationType() === "planned" ? "activity" : "warning"));

  openDialog(message: NotificationType) {
    this.dialog.open(DialogActivityComponent, {
      data: message,
    });
  }
}
